// extracted by mini-css-extract-plugin
module.exports = {"Button":"BobCancelButton_Button__20qp4"};